import UrlPreview from './UrlPreview';
import UrlPreviews from './UrlPreviews';

export default UrlPreviews;
export { UrlPreview };
